module.exports = __webpack_public_path__ + "img/community-people.67a89a97.svg";